import axios from 'axios';
import _ from 'underscore';

import { CollectionMapper } from '~src/Collections/mappers/CollectionMapper';
import { ListResult } from '~src/httpClient/fetchers/ListResult';
import { BaseParamsBuilderResourceQuery } from '~src/httpClient/resources/ResourceQuery';
import { IFieldValue } from '~src/httpClient/serverApi/types/IFieldValue';
import { FilterOps, ILeafFilterClause, IStringValuedFilterClause } from '~src/spacesPlatform/models/IFilterClause';

import { COLLECTIONS_PATH, collectionsAxiosRequestConfig, getFilterUrlParam } from './CollectionResourceQueryHelpers';

export interface FieldValue {
  readonly count: number;
  readonly label: string;
  readonly value: string;
}

export type GetFieldValuesResponse = FieldValue[];

abstract class FieldValuesQuery extends BaseParamsBuilderResourceQuery<IFieldValue> {

  private matchText: string = '';

  abstract getUrl(): string;

  public getSlice(start: number, size: number): Promise<ListResult<IFieldValue>> {
    let queryParams: {search?: string, sort?: string, filter?: string, labelMatchText?: string} = {};
    let filters: ILeafFilterClause[] = this.getFilters();
    const matchesFilter = filters.find((clause) => clause.operator === FilterOps.matches);
    if (matchesFilter) {
      const searchTerm = (matchesFilter as IStringValuedFilterClause).value;
      queryParams.search = searchTerm;
    }

    const filterParams = getFilterUrlParam(this.getFilters());

    if(filterParams) {
      queryParams.filter = filterParams;
    }

    if (this.matchText) {
      queryParams.labelMatchText = `"${this.matchText}"`;
    }

    queryParams = Object.assign(queryParams, this.getExtraParams());

    let queryString = '';
    if (!_.isEmpty(queryParams)) {
      queryString = '?';
      queryString += _.pairs(queryParams).map((value) => value[0]+'='+value[1]).join('&');
    }

    const url = this.getUrl() + queryString;
    const requestConfig = collectionsAxiosRequestConfig('GET', url);
    return axios.request<GetFieldValuesResponse>(requestConfig)
      .then(CollectionMapper.mapFieldValuesList)
      .catch((error) => Promise.reject(error.data));
  }

  public withMatchText(matchText: string) {
    this.matchText = matchText;
    return this;
  }

  public getCount(): Promise<number> {
    throw new Error('FieldValuesQuery getCount not implemented.');
  }

  public getFirst(): Promise<any> {
    throw new Error('FieldValuesQuery getFirst not implemented.');
  }
}


export class CollectionItemsFieldValuesQuery extends FieldValuesQuery {
  public constructor(private collectionLuid: string, private filterField: string) {
    super();
  }

  getUrl(): string {
    return COLLECTIONS_PATH + '/' + this.collectionLuid + '/items/' + this.filterField + '/counts';
  }
}

export class CollectionFieldValuesQuery extends FieldValuesQuery {

  public constructor(private filterField: string) {
    super();
  }

  getUrl(): string {
    return COLLECTIONS_PATH + '/' + this.filterField + '/counts';
  }
}
